import flatpickr from "flatpickr"
 
import {default as fp_en} from "flatpickr/dist/l10n/default.js";
// import {default as fp_va } from "./vue-i18n/langs/flatpickr/va.js";
import {Catalan as fp_cat } from "flatpickr/dist/l10n/cat.js";
import {Spanish as fp_es} from "flatpickr/dist/l10n/es.js";
import {French as fp_fr} from "flatpickr/dist/l10n/fr.js";
import {German as fp_de} from "flatpickr/dist/l10n/de.js";
import {Portuguese as fp_pt} from "flatpickr/dist/l10n/pt.js";

// Requiere que ya esté cargado vuex en la instancia de Vue
// Requiere que ya existe vue-i18n

const LanguagePlugin = {
  install(Vue) {
    // Idioma seleccionado en el navegador
    const languageStorageKey = 'app-language'

    // Idioma por defecto de flatpickr
    const flatpickrDefaultLanguage = 'es'

    // Idiomas disponibles
    const availableLanguages = Vue.store.state.languages

    // Idioma por defecto
    const defaultLanguage = availableLanguages[0]

    // Recupera el idioma del alamacenamiento local
    const getStoredLanguage = () => localStorage.getItem(languageStorageKey)

    // Recupera el idioma de la store
    const getLanguage = () => Vue.store.state.language

    // Guarda el idioma en el almacenamiento local
    const setStoredLanguage = language => {
      localStorage.setItem(languageStorageKey, language)
    }

    // Método para cargar un idioma en flatpickr

    function getFlatpickerLang(lang){
      switch (lang) {
        case 'va':
          flatpickr.localize(fp_cat)
          break
        case 'es':
          flatpickr.localize(fp_es)
          break
        case 'en':
          flatpickr.localize(fp_en)
          break
        case 'fr':
          flatpickr.localize(fp_fr)
          break
        case 'pt':
          flatpickr.localize(fp_pt)
          break
        case 'de':
          flatpickr.localize(fp_de)
          break
        default:
          getFlatpickerLang(flatpickrDefaultLanguage)
          break
      }
    }

    // Instantiate default language
    let languageConfig = getFlatpickerLang(flatpickrDefaultLanguage)

    // Método para cambiar el idioma de flatpickr
    const changeFlatpickrLanguage = language => {
      try {
        languageConfig = getFlatpickerLang(language)
      } catch (error) {
        console.error(error)
        console.error('El lenguaje no existe')
      }
      // Flatpickr está globalmente en toda la aplicación y requiere un reload de la página
      flatpickr.localize(languageConfig)
    }

    // Método para cambiar el idioma de nuestra app
    const changeAppLanguage = language => {
      Vue.i18n.locale = language
    }

    // Método para cambiar el idioma de moment
    const changeMomentLanguage = language => {
      let momentLanguage = language === 'va' ? 'ca' : language
      moment.locale(momentLanguage)
    }

    // Carga el idioma seleccionado y lo configura en la plataforma
    const loadStoredLanguage = () => {
      let storedLanguage = getStoredLanguage()

      if (!storedLanguage) {
        // Inicializar idioma de la app
        setStoredLanguage(defaultLanguage)
        storedLanguage = getStoredLanguage()
      }

      const language = storedLanguage.toLowerCase()

      Vue.store.commit('setLanguage', language)
      changeAppLanguage(language)
      changeMomentLanguage(language)
      changeFlatpickrLanguage(language)
    }

    // Cambia todo el idioma de la plataforma
    const changeLanguage = language => {
      setStoredLanguage(language)
      loadStoredLanguage()
    }

    const language = {
      availableLanguages,
      loadStoredLanguage,
      changeLanguage,
      getLanguage
    }

    Vue.language = language
    Vue.prototype.$language = language

    Vue.language.loadStoredLanguage()
  }
}

Vue.use(LanguagePlugin)
